const $$splitComponentImporter = () => import('/app/src/routes/forgot-password.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/forgot-password")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: (search: Record<string, unknown>) => ({
    email: (typeof search.email === "string" ? search.email : "") as string
  })
});